// extracted by mini-css-extract-plugin
module.exports = {"collapse":"Collapse_collapse__LlQmD","title":"Collapse_title__TL2LJ","hide":"Collapse_hide__DzY1T","show":"Collapse_show__M01V1"};